/* eslint-disable import/no-default-export */
import { API } from '@/api'
const state = {
  classList: [], // 一级菜单
  class2List: [], // 二级菜单
  classIndex: -1, // 激活的一级菜单 Index
  class2Index: -1, // 激活的二级菜单 Index
  class2Name: '分类',
  filterOpen: false, // 筛选框显示
  filterList: [], // 筛选-可筛选的所有菜品名称
  filterKey: [], // 筛选-选中的菜品名称
  brandList: [], // 筛选-可筛选的所有品牌
  selectedBrand: '', // 筛选-选中的品牌名称
  searchSkuList: [], // 活动列表数据
  isLast: false, // 是否最后一页
  loading: true,
  filterSort: false,
  minPrice: '',
  maxPrice: '',
  keyword: '',
  sale_c1_id: '',
  clearStateData: false,
  queryData: {
    page: 0
    // bottomPrice: '', // 最小值
    // topPrice: '', // 最大值
    // salec1Id: 0, // 一级分类id
    // saleC2Id: 0, // 二级分类id
    // sortType: '', //  排序方式，1 价格升序 2 价格降序 不传默认排序
    // keyword: '', //  搜索关键字
    // brands: [], //  筛选品牌
    // biNames: [], //  筛选名称
    // promotionId: '', //  活动Id(或者优惠券id)
    // promoteRuleId: '', //  阶段规则id(当为阶段运营时必传)
    // promoteStageId: '', //  阶段id(当为阶段运营时必传)
    // promoteType: '' //  活动类型（1-优惠券去使用，2-满买赠去凑单
    // actionId: '' //  阶段运营 购物车、商品详情
  }
}

const mutations = {
  classInit(state, action) {
    state.classList = action
  },
  navListBuild(state, action) {
    state.class2List = action.list
  },
  navListUpdate(state, payload) {
    payload.forEach(item => {
      state[item.key] = item.value
    })
  },
  filterOpen(state, action) {
    if (action === undefined) {
      state.filterOpen = !state.filterOpen
    } else {
      state.filterOpen = action
    }
  },
  filterListInit(state, action) {
    state.filterList = action.filterList || []
    state.filterKey = []
    state.brandList = action.brandList || []
    state.selectedBrand = ''
  },
  filterInit(state, action) {
    state.filterOpen = false
    state.scoreOpen = false
    state.filterKey = []
    state.selectedBrand = ''
  },
  filterSelect(state, action) {
    if (action === 0) {
      state.filterKey = []
    } else {
      state.filterKey = [...action]
    }
  },
  brandSelect(state, action = '') {
    state.selectedBrand = action
  },
  initeSkuList(state, action) {
    if (!action) {
      state.isLast = true
    } else {
      state.isLast = !!action.isLast
      const skuLists = action?.skuList || []
      const searchSkuListTemp = state.searchSkuList.concat(skuLists)
      const searchSkuList = searchSkuListTemp.map(ssuItem => {
        const ssu = Object.assign({}, ssuItem, {
          ssuInfo: ssuItem?.ssuList ? ssuItem?.ssuList[0] : {}
        })
        return ssu
      })
      state.searchSkuList = searchSkuList
      state.brandList = action.brandList
      state.filterList = action.biList
    }
  },
  setActQueryData(state, data) {
    state.queryData = Object.assign(state.queryData, data)
  },
  loadingSwitch(state, action) {
    state.loading = action
  },
  clearSkuList(state, action) {
    state.searchSkuList = []
  },
  clearQueryData(state, action) {
    state.queryData.bottomPrice = ''
    state.queryData.topPrice = ''
    state.queryData.saleC1Id = 0
    state.queryData.saleC2Id = 0
    state.queryData.sortType = ''
    state.queryData.keyword = ''
    state.queryData.brands = ''
    state.queryData.biNames = []
    state.filterList = []
    state.filterKey = []
    state.brandList = []
    state.selectedBrand = ''
    state.minPrice = ''
    state.maxPrice = ''
    state.keyword = ''
  },
  clearData(state) {
    state.classList = []
    state.class2List = []
    state.classIndex = -1
    state.class2Index = -1
    state.class2Name = '分类'
    state.filterOpen = false
    state.filterList = []
    state.filterKey = []
    state.brandList = []
    state.selectedBrand = ''
    state.searchSkuList = []
    state.isLast = ''
    state.loading = true
    state.queryData = {}
    state.filterSort = false
    state.minPrice = ''
    state.maxPrice = ''
    state.keyword = ''
    state.sale_c1_id = ''
  },
  setFilterSort(state, action) {
    state.filterSort = action
  },
  setPrice(state, action) {
    state[action.type] = action.value
  },
  setKeyWord(state, action) {
    state.keyword = action
  },
  setSallClass1Id(state, action) {
    state.sale_c1_id = action
  },
  clearClass2Index(state, action) {
    state.class2Index = -1
  },
  clearStateData(state, action) {
    state.clearStateData = action
  }
}

const actions = {
  // 根据活动id或优惠券id获得商品所属的一级二级分类
  classInit({ commit }, data) {
    commit('classInit', data)
  },
  // 根据活动id/优惠券id获取活动商品列表
  getActivitySkuList({ commit }, data) {
    commit('loadingSwitch', true)
    const options = {
      size: 10
    }
    const params = Object.assign({}, data, options)
    return API.activity.polymerizeProduct(params).then(res => {
      commit('loadingSwitch', false)
      commit('initeSkuList', res)
      return res
    })
  },
  setSkuList({ commit }, data) {
    commit('initeSkuList', data)
  },

  // 一级分类点击
  class1ListClick({ commit }, { item, index }) {
    if (item.id === 0) {
      commit('navListUpdate', [
        {
          key: 'class2Name',
          value: item.name
        }
      ])
    }
    commit('navListUpdate', [
      {
        key: 'class2List',
        value: item.class2List
      },
      {
        key: 'classIndex',
        value: index
      }
    ])
  },
  // 二级分类点击
  class2ListClick({ commit }, { item, index }) {
    commit('navListUpdate', [
      {
        key: 'class2Name',
        value: item.name
      },
      {
        key: 'class2Index',
        value: index
      }
    ])
  },
  // 开关筛选区域
  openFilter({ commit }, ifOpen) {
    commit('filterOpen', ifOpen)
  },
  // 选中筛选条件 （促销、排序、筛选三者互斥）
  selectFilter({ commit, state }, { ids, brand }) {
    commit('filterOpen', false)
    commit('filterSelect', ids)
    commit('brandSelect', brand)
  },
  setActQueryData({ commit }, data) {
    commit('setActQueryData', data)
  },
  clearSkuList({ commit }) {
    commit('clearSkuList')
  },
  clearData({ commit }) {
    commit('clearData')
  },
  setFilterSort({ commit }, data) {
    commit('setFilterSort', data)
  },
  clearQueryData({ commit }, data) {
    commit('clearQueryData', data)
  },
  setPrice({ commit }, data) {
    commit('setPrice', data)
  },
  setKeyWord({ commit }, data) {
    commit('setKeyWord', data)
  },
  setSallClass1Id({ commit }, data) {
    commit('setSallClass1Id', data)
  },
  clearClass2Index({ commit }, data) {
    commit('clearClass2Index', data)
  },
  clearStateData({ commit }, data) {
    commit('clearStateData', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
